module.exports = __webpack_public_path__ + "img/postfinance-alternate2.272595ae.png";